import React, { useState } from 'react';

const Seventenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Solar Flare */
            --primary: #ea580c;       /* Orange 600 */
            --primary-dark: #9a3412;  /* Orange 800 */
            --accent: #fcd34d;        /* Amber 300 */
            --bg-body: #fffbeb;       /* Amber 50 */
            --bg-white: #ffffff;
            --text-dark: #431407;     
            
            --font-main: 'Poppins', sans-serif;
            --radius: 20px;
        }

        body { font-family: var(--font-main); color: var(--text-dark); background-color: var(--bg-body); margin: 0; }
        a { text-decoration: none; color: inherit; transition: 0.3s; }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 20px; }
        
        .btn { background: var(--primary); color: white; padding: 10px 25px; border-radius: 50px; font-weight: 600; border: none; cursor: pointer; box-shadow: 0 5px 15px rgba(234, 88, 12, 0.3); }
        .btn:hover { transform: scale(1.05); background: var(--primary-dark); }
        
        .header { background: white; padding: 20px 0; border-bottom: 3px solid var(--accent); }
        .header .container { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.8rem; font-weight: 800; color: var(--primary); }
        
        .hero { background: url('https://images.unsplash.com/photo-1509316975850-ff9c5deb0cd9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80') center/cover; padding: 150px 0; text-align: center; color: white; position: relative; }
        .hero::before { content: ''; position: absolute; inset: 0; background: linear-gradient(to right, rgba(234,88,12,0.8), rgba(251,191,36,0.6)); }
        .hero-content { position: relative; z-index: 1; }
        .hero h1 { font-size: 3.5rem; margin-bottom: 20px; text-shadow: 2px 2px 4px rgba(0,0,0,0.2); }
        
        .section { padding: 80px 0; }
        .title { text-align: center; font-size: 2.5rem; margin-bottom: 50px; color: var(--primary-dark); }
        
        .card-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 30px; }
        .card { background: white; padding: 30px; border-radius: var(--radius); box-shadow: 0 10px 20px rgba(0,0,0,0.05); text-align: center; border-bottom: 5px solid var(--primary); transition: 0.3s; }
        .card:hover { transform: translateY(-10px); }
        
        .img-circle { width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 20px; overflow: hidden; border: 3px solid var(--accent); }
        .img-circle img { width: 100%; height: 100%; object-fit: cover; }
        
        .product-card { background: white; border-radius: 10px; overflow: hidden; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
        .product-img { height: 220px; }
        .product-img img { width: 100%; height: 100%; object-fit: cover; }
        .product-body { padding: 20px; }
        
        .footer { background: #333; color: white; padding: 50px 0; text-align: center; }
        .socials a { color: var(--accent); margin: 0 10px; font-size: 1.2rem; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;800&display=swap" rel="stylesheet" />

            <div className="header">
                <div className="container">
                    <div className="brand">{get_data.service_name}</div>
                    <a href="#contact" className="btn">Get in Touch</a>
                </div>
            </div>

            <div className="hero">
                <div className="container hero-content">
                    <h1>Bright Ideas, Brighter Future</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '30px'}}>Igniting potential with top-tier services and products.</p>
                    <a href="#services" className="btn" style={{background: 'white', color: 'var(--primary)'}}>See Services</a>
                </div>
            </div>

            <div className="section" id="services">
                <div className="container">
                    <h2 className="title">Our Spark</h2>
                    <div className="card-grid">
                        {get_data.categories && get_data.categories.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="img-circle">
                                     {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} alt={item.name}/> : <span style={{lineHeight: '80px', fontSize: '2rem'}}>☀</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <p style={{margin: '15px 0', color: '#666'}}>{item.description || 'Lighting the way.'}</p>
                                <a href="#contact" style={{color: 'var(--primary)', fontWeight: 'bold'}}>Enquire Now →</a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            
            <div className="section" id="products" style={{background: 'white'}}>
                <div className="container">
                     <h2 className="title">Hot Picks</h2>
                     <div className="card-grid">
                          {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="product-img">
                                     <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>
                                </div>
                                <div className="product-body">
                                    <h3>{item.service_name}</h3>
                                    {item.price && <div style={{color: 'var(--primary)', fontSize: '1.2rem', fontWeight: 700, margin: '10px 0'}}>₹{item.price}</div>}
                                    <button onClick={() => addToCart(item)} className="btn" style={{width: '100%'}}>Order Now</button>
                                </div>
                            </div>
                        ))}
                     </div>
                </div>
            </div>

            <div className="footer" id="contact">
                <div className="container">
                    <h2>{get_data.service_name}</h2>
                    <p style={{margin: '20px 0'}}>{get_data.business_location_name}</p>
                    <div className="socials">
                         {get_data.facebook && <a href={get_data.facebook}>Facebook</a>}
                         {get_data.instagram && <a href={get_data.instagram}>Instagram</a>}
                    </div>
                    <p style={{marginTop: '30px', fontSize: '0.8rem', opacity: 0.6}}>&copy; {new Date().getFullYear()} All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default Seventenththeme;
